import PropTypes from "prop-types";
import React from "react";
import { subscribeLinkType } from "../common/types";

export function Trial({ description, subscribeLink }) {
	return (
		<section className="section--trial">
			<div className="container typography">
				<p className="section-title">Try us out before you buy!</p>
				<p className="section-description">{description}</p>
				<ul className="ticks ticks--small">
					<li>After 14 days, the trial ceases automatically</li>
					<li>No credit card required</li>
					<li>No commitment</li>
				</ul>
				<div className="btn-group">
					<a href={subscribeLink} className="btn btn--primary">
						Free 14-day trial
					</a>
					<a href={subscribeLink} className="btn btn--tertiary">
						See pricing options
					</a>
				</div>
			</div>
		</section>
	);
}

Trial.propTypes = {
	description: PropTypes.string.isRequired,
	subscribeLink: subscribeLinkType.isRequired,
};
